

<div id="page-menu" class="page-menu">
    <div class="container">
        <div class="row containing-row">
            <ul class="row w-ul">
                <ng-container *ngFor="let item of children">
                    <ng-container *ngIf="userKindCd == 'U10'">
                        <ng-container *ngIf="item.data.menuYn == 'Y'">
                            <li class="menu-item col-auto" [ngClass]="item.data.prgId === tempActiveId ? 'active' : ''">
                                <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgName }}</a>
                                <!-- <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgNameEn }}</a> -->
                            </li>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="userKindCd == 'U00'">
                        <ng-container *ngIf="item.data.menuYn == 'Y'
                                          && item.data.prgId != 'ml.Office.User-profile.Change-bank-account'
                                          && item.data.prgId != 'ml.Office.User-profile.Change-resident-id'
                                          && item.data.prgId != 'ml.Office.Order-management.Sub-order-search'
                                          && item.data.prgId != 'ml.Office.Order-management.Order-product-search'
                                          && item.data.prgId != 'ml.Office.Order-management.Order-calendar'
                                          && item.data.prgId != 'ml.Office.Order-management.Monthly-order-count'
                                          && item.data.prgId != 'ml.Office.Order-management.Order-mileage-inquiry'">
                            <li class="menu-item col-auto" [ngClass]="item.data.prgId === tempActiveId ? 'active' : ''">
                                <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgName }}</a>
                                <!-- <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgNameEn }}</a> -->
                            </li>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
    </div>
</div>
